var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:{ 'pt-4': typeof _vm.title !== 'undefined' }},[_c('div',{staticClass:"title subtitle-2 font-weight-regular",class:{
            required: !!_vm.required,
            'font-weight-bold': !!_vm.required,
        }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }